export const KeyboardArrowDown = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
      <path
        d="M6.70711 6.69289C6.31658 7.08342 5.68342 7.08342 5.29289 6.69289L0.7 2.1C0.313401 1.7134 0.313401 1.0866 0.7 0.7C1.0866 0.313401 1.7134 0.313401 2.1 0.7L5.29289 3.89289C5.68342 4.28342 6.31658 4.28342 6.70711 3.89289L9.9 0.7C10.2866 0.3134 10.9134 0.313401 11.3 0.7C11.6866 1.0866 11.6866 1.7134 11.3 2.1L6.70711 6.69289Z"
        fill="currentColor"
      />
    </svg>
  )
}
